/**
 * Parses a string as a decimal price. Allows empty, digits, and one decimal point.
 * Returns null for invalid or empty input.
 */
export function parsePriceInput(raw: string): number | null {
  const trimmed = raw.trim().replace(/,/g, ".");
  if (trimmed === "" || trimmed === ".") return null;
  const num = Number(trimmed);
  return Number.isFinite(num) && num >= 0 ? num : null;
}

/**
 * Formats a number for display (e.g. in readonly or after blur).
 * Uses 2 decimal places; avoids "NaN" or empty when value is invalid.
 */
export function formatPrice(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return "";
  return Number(value).toFixed(2);
}
